import { Component, input, output } from "@angular/core"
import { CdkTrapFocus } from "@angular/cdk/a11y"

/*
* If drawer component gets used by other components then
* we will need to pass in additional props for accessibility.
* */

@Component({
  imports: [
    CdkTrapFocus,
  ],
  standalone: true,
  template: `
    <div
      class="drawer"
      style="z-index: 10000"
      (keydown.escape)="cancelAndClose.emit()"
    >
      <input
        type="checkbox"
        id="drawer-toggle"
        class="drawer-toggle"
        aria-label="Toggle Navigation Menu"
        [checked]="show()"
      />
      @if (show()) {
        <div
          class="drawer-side"
          role="navigation"
          cdkTrapFocus
          cdkTrapFocusAutoCapture
        >
          <label
            for="drawer-toggle"
            class="drawer-overlay"
            aria-label="Close Navigation Menu"
            (click)="cancelAndClose.emit()">
          </label>

          <ng-content ngProjectAs="content"></ng-content>

        </div>
      }
    </div>
  `,
  selector: "lib-ui-drawer",
})
export class UiDrawerComponent {
  show = input(false)
  cancelAndClose = output()
}
